export default __webpack_public_path__ + "static/media/tick-icon-green.71748f23.svg";